import { lazyLoad } from 'app/utils/loadable';

export const ActivationPageOverlap = lazyLoad(
  () => import('./activation-page-overlap'),
  (module) => module.ActivationPageOverlap
);
